import { createYoursLoginProof } from './yours-wallet-auth'

export interface RecoveryGrant {
    id: string
    recovery_token: string
}

export async function recoveryRequest(
    action: string,
    body: Record<string, unknown>,
    grant?: RecoveryGrant,
) {
    const response = await fetch(`${window.knovApiUrl}/api/v1/wallet_recoveries${action}`, {
        method: 'POST',
        credentials: 'omit',
        headers: {
            'Content-Type': 'application/json',
            ...(grant ? { Authorization: `Bearer ${grant.recovery_token}` } : {}),
        },
        body: JSON.stringify(body),
    })
    const data = await response.json().catch(() => ({}))
    if (!response.ok) {
        throw new Error(data.error || 'Recovery could not continue. Please try again shortly.')
    }
    return { response, data }
}

export async function verifyRecoveryWallet(): Promise<RecoveryGrant & { name: string }> {
    let grant: RecoveryGrant | undefined
    const proof = await createYoursLoginProof(async identityKey => {
        const { data } = await recoveryRequest('', { identity_key: identityKey })
        grant = { id: data.id, recovery_token: data.recovery_token }
        return data.message
    })
    if (!grant) throw new Error('Recovery could not start. Please try again.')
    const { data } = await recoveryRequest(
        `/${grant.id}/verify`,
        { signature: proof.sig, signature_scheme: proof.signature_scheme },
        grant,
    )
    return { ...grant, name: data.name }
}
